import React, { useState } from 'react';

function ImageWithRetry({ src = '', alt = '', title = '', fallbackText = 'Image failed to load.' }) {
  const [imgSrc, setImgSrc] = useState(src);
  const [hasError, setHasError] = useState(false);
  const [reloadKey, setReloadKey] = useState(0); // Used to force reload

  const handleError = () => {
    setHasError(true);
  };

  const handleReload = () => {
    setHasError(false);
    setReloadKey(prev => prev + 1); // Change key to force re-render
    setImgSrc(`${src}?reload=${Date.now()}`); // Bypass cache
  };

  return (
    <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
      {!hasError ? (
        <img
          key={reloadKey}
          src={imgSrc}
          title={title}
          alt={alt}
          // alt='no error'
          onError={handleError}
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      ) : (
        <div style={{ width: 'fit-content', padding: 7, border: '5px solid cornflowerblue', borderRadius: 10 }}>
          <p>{fallbackText}</p>
          <button className='btn btn-primary' onClick={handleReload}><i className='fa fa-refresh'></i> Reload Image</button>
        </div>
      )}
    </div>
  );
};

export default ImageWithRetry;